import { XIcon } from '@phosphor-icons/react';

/** Removable thumbnails for the images staged on a composer. */
export function ImageThumbnails({ images, onRemove }: { images: string[]; onRemove: (index: number) => void }) {
  if (images.length === 0) return null;
  return (
    <div className="flex flex-wrap items-center gap-2">
      {images.map((image, i) => (
        <span key={image.slice(-32) + i} className="relative">
          <img src={image} alt={`Attachment ${i + 1}`} className="size-14 rounded-lg border border-line object-cover" />
          <button
            type="button"
            onClick={() => onRemove(i)}
            aria-label={`Remove attachment ${i + 1}`}
            className="absolute -top-1.5 -right-1.5 rounded-full border border-line bg-surface-2 p-0.5 text-fg-secondary hover:text-fg"
          >
            <XIcon size={10} />
          </button>
        </span>
      ))}
    </div>
  );
}
